// extracted by mini-css-extract-plugin
module.exports = {"submitBtnWrapper":"GroupCreationSubmitButtons_submitBtnWrapper_2OUYn","exitButton":"GroupCreationSubmitButtons_exitButton_1wy3k"};